'use client'
import { RHFOTPInput } from '@/components/form/rhf-otp-input'
import { Box, Stack, Typography } from '@mui/material'
import dayjs from 'dayjs'
import { useTranslations } from 'next-intl'
import { ReactNode, useEffect, useState } from 'react'

type Props = {
  subtitle?: string | ReactNode
  onSubmit?: Function
  align?: 'left' | 'center' | 'right'
  onResendOTP?: () => Promise<void> | void
  errorMessage?: string | null
}

export const OTPCountDown = ({ subtitle, onSubmit, align, onResendOTP, errorMessage }: Props) => {
  const t = useTranslations('UserProfile')
  const [second, setSecond] = useState(300)
  const [isResending, setIsResending] = useState(false)

  useEffect(() => {
    let timer: NodeJS.Timeout
    if (second > 0) {
      timer = setTimeout(() => {
        setSecond((prev) => prev - 1)
      }, 1000)
    }
    return () => clearTimeout(timer)
  }, [second])

  const handleResendOTP = async () => {
    if (isResending || !onResendOTP) return

    setIsResending(true)
    try {
      await onResendOTP()
      // Reset countdown sau khi gửi lại thành công
      setSecond(300)
    } catch (error) {
      console.error('Error resending OTP:', error)
    } finally {
      setIsResending(false)
    }
  }
  const onSubmitOTP = (value: string) => {
    if (onSubmit) {
      onSubmit(value)
    }
  }
  return (
    <Stack spacing={1} textAlign={align || 'left'} alignItems={align === 'center' ? 'center' : 'flex-start'}>
      <Typography
        variant="subtitle1"
        sx={{
          fontSize: {
            xs: '0.75rem',
            md: '0.875rem',
          },
          textAlign: align || 'left',
          fontWeight: 300,
        }}
        textAlign={align || 'left'}
        alignItems={align === 'center' ? 'center' : 'flex-start'}
      >
        {subtitle ||
          t('Vui lòng nhập đoạn mã bao gồm 6 chữ số vừa gửi về e-mail số điện thoại của bạn vào đây')}
      </Typography>
      <Stack spacing={1}>
        <RHFOTPInput length={6} name="otp" onComplete={onSubmitOTP} />
        {errorMessage && (
          <Typography
            variant="body2"
            color="error"
            sx={{ fontSize: { xs: '0.75rem', md: '0.875rem' }, fontWeight: 300 }}
          >
            {errorMessage}
          </Typography>
        )}
      </Stack>
      <Typography
        variant="body2"
        sx={{
          fontSize: {
            xs: '0.75rem',
            md: '0.875rem',
          },
          mt: 1,
          fontWeight: 300,
        }}
      >
        {t('Bạn chưa nhận được mã')}
        <Typography
          component="span"
          sx={{
            color: 'five.main',
            cursor: second > 0 || isResending ? 'default' : 'pointer',
            fontWeight: 500,
            fontSize: '1em',
            ml: 0.5,
            opacity: isResending ? 0.6 : 1,
          }}
          onClick={() => {
            if (second === 0 && !isResending) {
              handleResendOTP()
            }
          }}
        >
          {second > 0 ? (
            <>{t('Vui lòng thử lại sau', { time: dayjs.unix(second).format('mm:ss') })}</>
          ) : isResending ? (
            <>{t('Đang gửi')}</>
          ) : (
            <>{t('Gửi lại mã')}</>
          )}
        </Typography>
      </Typography>
    </Stack>
  )
}
